import _sfc_main from "./MediaCenterHeroImage2.mjs";
import { openBlock, createElementBlock, normalizeClass, createBlock, KeepAlive, resolveDynamicComponent, createCommentVNode, createElementVNode, withKeys, mergeProps } from "vue";
/* empty css                       */
import _export_sfc from "../../../../_virtual/_plugin-vue_export-helper.mjs";
const _hoisted_1 = ["tabindex", "role", "aria-haspopup", "aria-label"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("div", {
    ref: "mainContainer",
    class: normalizeClass(["media-center-hero", `media-center-hero--${_ctx.layout}`]),
    style: {
      "left": "0px"
    }
  }, [_ctx.computedPrev.uri ? (openBlock(), createElementBlock("div", {
    key: 0,
    ref: "prevContainer",
    class: normalizeClass(["media-center-hero__img-wrapper media-center-hero__img-wrapper--prev", `media-center-hero__img-wrapper--prev--${_ctx.layout}`])
  }, [(openBlock(), createBlock(KeepAlive, null, [(openBlock(), createBlock(resolveDynamicComponent(_ctx.getComponentType(_ctx.computedPrev)), {
    ref: "prev",
    title: "",
    index: "prev",
    "should-pad": _ctx.getShouldPad(_ctx.computedPrev),
    "is-focusable": false,
    layout: _ctx.layout,
    user: _ctx.computedPrev.type === "UGC Image" ? _ctx.computedPrev.user : null,
    "posted-date": _ctx.computedPrev.type === "UGC Image" ? _ctx.computedPrev.postedDate : null,
    "image-src": _ctx.computedPrev.uri,
    "video-src": _ctx.computedPrev.type === "video" ? _ctx.computedPrev.src : null
  }, null, 8, ["should-pad", "layout", "user", "posted-date", "image-src", "video-src"]))], 1024))], 2)) : createCommentVNode("", true), createElementVNode("div", {
    ref: "currentContainer",
    class: normalizeClass(["media-center-hero__img-wrapper", [`media-center-hero__img-wrapper--${_ctx.layout}`, {
      "media-center-hero__img-wrapper--zoomable": _ctx.isStandardImage
    }]]),
    tabindex: _ctx.hasFocusableImage && _ctx.isStandardImage ? 0 : void 0,
    role: _ctx.hasFocusableImage ? "button" : void 0,
    "aria-haspopup": _ctx.hasFocusableImage ? "dialog" : void 0,
    "aria-label": _ctx.hasFocusableImage ? "View larger image" : void 0,
    onKeydown: [_cache[3] || (_cache[3] = withKeys(() => _ctx.isStandardImage ? _ctx.handleHeroClick() : void 0, ["enter"])), _cache[4] || (_cache[4] = withKeys(() => _ctx.isStandardImage ? _ctx.handleHeroClick() : void 0, ["space"]))],
    onClick: _cache[5] || (_cache[5] = () => _ctx.isStandardImage ? _ctx.handleHeroClick() : void 0)
  }, [(openBlock(), createBlock(KeepAlive, null, [_ctx.currentDisplayImage.uri ? (openBlock(), createBlock(resolveDynamicComponent(_ctx.getComponentType(_ctx.currentDisplayImage)), mergeProps({
    id: "media-center-primary-image",
    key: _ctx.currentDisplayImage.id,
    ref: "current",
    index: "curr"
  }, _ctx.isUgcImage ? _ctx.ugcImageProps : _ctx.genericMediaProps, {
    "data-color": _ctx.currentImage.color && _ctx.currentImage.color.name,
    "should-pad": _ctx.getShouldPad(_ctx.currentDisplayImage),
    "image-src": _ctx.currentDisplayImage.uri,
    "is-focusable": true,
    title: _ctx.currentDisplayImage.altText,
    onMetricsClick: _cache[0] || (_cache[0] = (data) => _ctx.$emit("metricsClick", data)),
    onResetVideo: _cache[1] || (_cache[1] = (data) => _ctx.resetVideo = data),
    onUgcImageClick: _cache[2] || (_cache[2] = (data) => _ctx.$emit("ugcImageClick", data))
  }), null, 16, ["data-color", "should-pad", "image-src", "title"])) : createCommentVNode("", true)], 1024))], 42, _hoisted_1), _ctx.computedNext.uri ? (openBlock(), createElementBlock("div", {
    key: 1,
    ref: "nextContainer",
    class: normalizeClass(["media-center-hero__img-wrapper media-center-hero__img-wrapper--next", `media-center-hero__img-wrapper--next--${_ctx.layout}`])
  }, [(openBlock(), createBlock(KeepAlive, null, [(openBlock(), createBlock(resolveDynamicComponent(_ctx.getComponentType(_ctx.computedNext)), {
    ref: "next",
    title: "",
    "should-pad": _ctx.getShouldPad(_ctx.currentDisplayImage),
    user: _ctx.computedNext.type === "UGC Image" ? _ctx.computedNext.user : null,
    "posted-date": _ctx.computedNext.type === "UGC Image" ? _ctx.computedNext.postedDate : null,
    layout: _ctx.layout,
    "is-focusable": false,
    "image-src": _ctx.computedNext.uri,
    lazy: _ctx.computedCurrentIndex === 0,
    "video-src": _ctx.computedNext.type === "video" ? _ctx.computedNext.src : ""
  }, null, 8, ["should-pad", "user", "posted-date", "layout", "image-src", "lazy", "video-src"]))], 1024))], 2)) : createCommentVNode("", true)], 2);
}
const MediaCenterHeroImage = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-9fed5c31"]]);
export {
  MediaCenterHeroImage as default
};
//# sourceMappingURL=MediaCenterHeroImage.mjs.map
